import { createContext, useContext } from "react"
import { Member, MemberMetaData, RosterData } from "../api/models/member"


export type MemberContent = {
    member?: Member,
    rosterData?:RosterData;
    isLeader?: boolean;
    isLoadingMetaData?: boolean;
    refreshMember: () => Promise<void>;
    updateName: (firstName: string, lastName:string) => Promise<void>;
    updateBirthDate: (birthDate:string) => Promise<void>;
    updateContactInfo: (phone:string, email: string) => Promise<void>;
    updateMetaData: (metaData: MemberMetaData) => Promise<void>;
    updateJerseyNumber: (jerseyNumber: string) => Promise<void>;
    updatePosition: (position: string) => Promise<void>;
    updateTitle: (title: string) => Promise<void>;
    updateActionImage: (actionImage: string) => Promise<void>;
    updatePersonalPage: (athletePage: string, isPublic: boolean) => Promise<void>;
    updateDocument: (document: string) => Promise<void>;
    resetPin: () => Promise<void>;

}

export const MemberContext = createContext<MemberContent>({
    member: undefined,
    rosterData: undefined,
    isLeader: false,
    isLoadingMetaData: false,
    refreshMember: async () => {},
    updateName: async () => {},
    updateBirthDate: async () => {},
    updateContactInfo: async () => {},
    updateMetaData: async () => {},
    updateJerseyNumber: async () => {},
    updatePosition: async () => {},
    updateTitle: async () => {},
    updateActionImage: async () => {},
    updatePersonalPage: async () => {},
    updateDocument: async () => {},
    resetPin: async () => {}
})

export const useMemberContext = () => useContext(MemberContext)